import React, { useEffect, useState, useContext } from "react";
import BannerSection from "../inc/BannerSection";
import Banner from "../images/banner.jpg";
import Functions from "../../utility/services/Functions";
import ApiService from "../../utility/services/ApiService";
import { AuthContext } from "../../utility/services/AuthContext";
import { trackScreenView, getUserTrackingParams } from "../../utility/services/analyticsService";

const TermsOfService = () => {
  const pageTitle = "Terms of Service";

  const [htmlContent, setHtmlContent] = useState("");

  const { setLoading, user } = useContext(AuthContext);
  const { consoleService } = Functions();
  const { get_specific_pages_details } = ApiService();

  useEffect(() => {
    trackScreenView("terms_of_service_screen", { screen_name: "Terms of Service", ...getUserTrackingParams(user) });
    get_initial_details();
  }, []);

  async function get_initial_details() {
    try {
      setLoading(true);
      const res = await get_specific_pages_details(pageTitle);
      if (res.status === 1) {
        setHtmlContent(res.data.des);
        setLoading(false);
      } else {
        consoleService("error in get_initial_details fun =- ", res.message);
      }
    } catch (err) {
      consoleService("error in get_initial_details fun = ", err);
    }
  }
  return (
    <>
      <section className="py-5 ">
        <div className="container">
          <div className="row">
            <div className="col-md-12 termHead">
              <h1>Terms of Service</h1>
            </div>
            <div
              className="col-md-12"
              dangerouslySetInnerHTML={{ __html: htmlContent }}
            ></div>
          </div>
        </div>
      </section>
    </>
  );
};

export default TermsOfService;
